import type { ReactNode } from "react";
import { cn } from "./cn";

type DashedCardProps = {
  children: ReactNode;
  light?: boolean;
  accent?: boolean;
  hover?: boolean;
  className?: string;
};

export function DashedCard({
  children,
  light,
  accent,
  hover = true,
  className,
}: DashedCardProps) {
  const borderColor = accent
    ? "border-accent"
    : light
      ? "border-dash-l"
      : "border-dash-d";

  return (
    <div
      className={cn(
        "border border-dashed rounded-lg p-8 transition-colors duration-200",
        borderColor,
        light ? "bg-white" : "bg-bg-2",
        hover && "hover:border-accent/60",
        className,
      )}
    >
      {children}
    </div>
  );
}
